export const pushToDataLayer = (...events) => {
	if (typeof window === 'undefined') return;
	window.dataLayer = window.dataLayer || [];
	events.forEach((event) => window.dataLayer.push(event));
};
